import React, { useState, useEffect, useRef } from 'react';
import './Icons.css'; // èëè èñïîëüçóéòå styled-components
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import BarrierIcon from './BarrierIcon.js';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import SvgIcon from '@mui/material/SvgIcon';
import { styled } from '@mui/material/styles';
import { CustomBarrierIcon } from './BarrierIcon.js';
import LinkedCameraIcon from '@mui/icons-material/LinkedCamera';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudOffIcon from '@mui/icons-material/CloudOff';

const BlinkingIcon = styled(SvgIcon)(({ theme }) => ({
  animation: 'blink 1.5s ease-in-out infinite',
  '@keyframes blink': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.2 },
    '100%': { opacity: 1 },
  },
}));

function StatusIcon({type, count, onlineCount}) {
  if (type === 0) {
    return (
      <div style={{marginTop: '3px'}}>
        {count==onlineCount && <CustomBarrierIcon color={"green"} style={{ color: "green" }}></CustomBarrierIcon>}
        {count!=onlineCount && <BarrierIcon color={"red"} style={{ color: "green" }}></BarrierIcon>}
      </div>
    );
  }
  else if (type === 1) {
    return (
      <div style={{marginTop: '5px'}}>
        {count!=onlineCount &&
          <BlinkingIcon
            component={LinkedCameraIcon}
            sx={{ fontSize: '40px', color: 'red'}}
          />}
        {count==onlineCount && <LinkedCameraIcon style={{ color: "green" }}></LinkedCameraIcon>}
      </div>
    );
  }
  else if (type === 2) {
    return (
      <div style={{marginTop: '5px'}}>
        {count!=onlineCount &&
          <BlinkingIcon
            component={CloudOffIcon}
            sx={{ fontSize: '40px', color: 'red'}}
          />}
        {count==onlineCount && <CloudDoneIcon style={{ color: "green" }}></CloudDoneIcon>}
      </div>
    );
  }
}

function Status({type, count, onlineCount}) {
    return (
      <>
        {/*onlineCount}/{count*/}
        <StatusIcon type={type} count={count} onlineCount={onlineCount}></StatusIcon>
      </>
    );
}

const IconContainer = ({ userId, systemState }) => {

  const [openCamerasStatus, setOpenCamerasStatus] = useState(false);
  const [openBarriersStatus, setOpenBarriersStatus] = useState(false);
  const [openScriptsStatus, setOpenScriptsStatus] = useState(false);

  const handleCamerasStatusClose = () => {
    setOpenCamerasStatus(false);
  };

  const handleCamerasStatusOpen = () => {
    setOpenCamerasStatus(true);
  };

  const handleBarriersStatusClose = () => {
    setOpenBarriersStatus(false);
  };

  const handleBarriersStatusOpen = () => {
    setOpenBarriersStatus(true);
  };

  const handleScriptsStatusClose = () => {
    setOpenScriptsStatus(false);
  };

  const handleScriptsStatusOpen = () => {
    setOpenScriptsStatus(true);
  };

  const [status, setStatus] = useState({
    total_cameras: 0,
    online_cameras: 0,
    total_boards: 0,
    online_boards: 0,
    updated_camera: null,
    updated_board: null,
    updated_script: null,
    isConnected: false,
  });
  const [isReconnecting, setIsReconnecting] = useState(false);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const ws = useRef(null);

  const MAX_RECONNECT_ATTEMPTS = 5;
  const RECONNECT_DELAY = 3000;

  useEffect(() => {
    let isMounted = true;

    const connect = () => {
      if (!isMounted) return;

      const socketUrl = `${process.env.REACT_APP_WEBSOCKET_BASE_URL}/system_state/${userId}/`;
      console.log(`Connecting to ${socketUrl} (attempt ${reconnectAttempts + 1})`);

      ws.current = new WebSocket(socketUrl);

      ws.current.onopen = () => {
        console.log('WebSocket connected');
        setStatus(prev => ({ ...prev, isConnected: true }));
        setIsReconnecting(false);
        setReconnectAttempts(0);
      }

      ws.current.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log("Received from WS: ", data);
          setStatus(data);
        } catch (error) {
          console.error("Failed to parse WS message: ", error)
        }
      };

      ws.current.onerror = (error) => {
        console.error("WebSocket error: ", error);
        console.log('Error code:', error.code);
        console.log('Error message:', error.message);
      };

      ws.current.onclose = (event) => {
        console.log("WebSocket disconnected: ", event);
        console.log('Close code:', event.code);
        console.log('Close reason:', event.reason);
        setStatus(prev => ({ ...prev, isConnected: false }));

        if (reconnectAttempts < MAX_RECONNECT_ATTEMPTS && isMounted) {
          setReconnectAttempts(prev => prev + 1);
          setIsReconnecting(true);
          console.log(`Reconnecting in ${RECONNECT_DELAY / 1000}s... (attempt ${reconnectAttempts + 1})`);

          setTimeout(connect, RECONNECT_DELAY);
        } else {
          console.warn("Max reconnect attempts reached. Stopping.");
        }
      };
    };

    connect();

    return () => {
      isMounted = false;
      if (ws.current) {
        ws.current.close();
      }
    }
  }, [userId, reconnectAttempts]);

  return (
    <div className="icon-container">
      <>
        <div
          className="icon"
          onClick={handleCamerasStatusOpen}
        >
          <Status type={1} count={status.total_cameras} onlineCount={status.online_cameras}></Status>
        </div>
        <div
          className="icon"
          onClick={handleBarriersStatusOpen}
        >
          <Status type={0} count={status.total_boards} onlineCount={status.online_boards}></Status>
        </div>
        <div
          className="icon"
          onClick={handleScriptsStatusOpen}
        >
          <Status type={2} count={status.total_scripts} onlineCount={status.online_scripts}></Status>
        </div>

        <Dialog
          open={openCamerasStatus}
          onClose={handleCamerasStatusClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <div style={{ color: ((status.total_cameras === status.online_cameras) && (status.online_cameras > 0)) ? 'green' : 'red'}}>
              {status.online_cameras} из {status.total_cameras} {status.total_cameras === 1 ? 'камеры' : 'камер' } онлайн!
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box
                component="section"
                noValidate
                autoComplete="off"
              >
                {/*}
                <InputLabel
                  id="contacts"
                >
                </InputLabel>
                {*/}
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCamerasStatusClose}>Закрыть</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openBarriersStatus}
          onClose={handleBarriersStatusClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <div style={{ color: ((status.total_boards === status.online_boards) && (status.online_boards > 0)) ? 'green' : 'red'}}>
              {status.online_boards} из {status.total_boards} {status.total_boards === 1 ? 'шлагбаума' : 'шлагбаумов' } онлайн!
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box
                component="section"
                noValidate
                autoComplete="off"
              >
                {/*}
                <InputLabel
                  id="contacts"
                >
                </InputLabel>
                {*/}
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleBarriersStatusClose}>Закрыть</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openScriptsStatus}
          onClose={handleScriptsStatusClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <div style={{ color: ((status.total_scripts === status.online_scripts) && (status.online_scripts > 0)) ? 'green' : 'red'}}>
              {((status.total_scripts === status.online_scripts) && (status.online_scripts > 0)) ? 'Подключение к облаку успешно!' : 'Проблемы с подключением к облаку!'}
            </div>
          </DialogTitle> 
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box
                component="section"
                noValidate
                autoComplete="off"
              >
                {/*}
                <InputLabel
                  id="contacts"
                >
                </InputLabel>
                {*/}
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleScriptsStatusClose}>Закрыть</Button>
          </DialogActions>
        </Dialog>
      </>
    </div>
  );
};

export default IconContainer;